import { FirstStepsItemList } from './FirstStepsItem';
import './FirstStepsDashboard.scss';
import { ApplicationOnboardingStateFunctionUtils } from './ApplicationOnboardingStateFunctionUtils';
import { CompletedItem } from './CompletedStepsItem';
import blipinhoIcon from './img/blipinho-party.png';
import template from './FirstStepsComponentView.html';
import { setOnboardingCompletedOnLocalStorage } from './FirstStepsOnboardingConstants';
import { ChannelsFeatures } from '../../channels/ChannelsFeatures';
const dashbotShowGetStarted = 'dashbot-show-getstarted';
var Steps;
(function (Steps) {
    Steps["create"] = "create";
    Steps["publish"] = "publish";
    Steps["test"] = "test";
    Steps["channels"] = "channels";
    Steps["finished"] = "finished";
})(Steps || (Steps = {}));
export class FirstStepsDashboardComponentController {
    static $inject = ['$rootScope', 'BuilderService', 'UsersService', '$state', 'ChannelsService', '$translate', 'SegmentService', 'applicationService2'];
    constructor($rootScope, BuilderService, UsersService, $state, ChannelsService, $translate, SegmentService, applicationService2) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.BuilderService = BuilderService;
        this.UsersService = UsersService;
        this.$state = $state;
        this.ChannelsService = ChannelsService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.applicationService2 = applicationService2;
        this.firstStepsItemList = FirstStepsItemList;
        this.completedStepsItem = CompletedItem;
        this.completedStepsIndex = [];
        this.allStepsCompleted = false;
        this.stepLabelTextList = [{ index: 0, text: '' }, { index: 1, text: '' }, { index: 2, text: '' }, { index: 3, text: '' }];
        this.enableStepperView = false;
        this.isCompletedOnboarding = false;
        this.enableStaticStepperView = false;
        this.blipPartyIcon = blipinhoIcon;
        this.TestersUserGroup = 'Testers';
    }
    async $onInit() {
        this.myApplication = await this.applicationService2.getApplication(this.$rootScope.application.shortName);
        const useConfigurationApplicationGet = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        const useGatewayConfigurationsEndpoint = await ChannelsFeatures.isGatewayConfigurationsFromNewEndpointEnabled();
        this.channels = await this.ChannelsService.getAllChannels(useConfigurationApplicationGet, useGatewayConfigurationsEndpoint);
        await this.loadStaticViewText();
        this.flowBucket = Object.keys(await this.BuilderService.getFlow(this.$rootScope.application));
        await this.verifyBotCompletedSteps();
        this.setCompletedOnboardingItensToStepper();
        if (await this.isOnboardingCompleted()) {
            this.enableStepperView = true;
            setOnboardingCompletedOnLocalStorage();
            return;
        }
        this.getCurrentActiveStep();
        await this.loadActiveItemViewText();
        this.enableStepperView = true;
        this.createStepTracking(true);
    }
    async isOnboardingCompleted() {
        if (this.completedStepsIndex.length === this.firstStepsItemList.length) {
            this.completedStepItemText = await this.$translate(this.completedStepsItem.mainText);
            this.completedStepItemDescription = await this.$translate(this.completedStepsItem.description);
            this.isCompletedOnboarding = true;
        }
        return this.isCompletedOnboarding;
    }
    async loadStaticViewText() {
        for (const [index, stepItem] of this.firstStepsItemList.entries()) {
            this.stepLabelTextList[index].text = await this.$translate(stepItem.stepLabel);
        }
        this.enableStaticStepperView = true;
    }
    async verifyBotCompletedSteps() {
        const users = await this.UsersService.getUsers('', 0, 20);
        const hasAnyTester = users.items.some((user) => user.group === this.TestersUserGroup);
        const applicationOnbardingStateFunctionUtils = new ApplicationOnboardingStateFunctionUtils(this.$rootScope.application, this.flowBucket, hasAnyTester, this.applicationService2, this.channels);
        await this.runOnboardingRules(applicationOnbardingStateFunctionUtils);
    }
    async runOnboardingRules(applicationOnbardingStateFunctionUtils) {
        await applicationOnbardingStateFunctionUtils.init();
        applicationOnbardingStateFunctionUtils.applicationStepsRules.every((stepRule, index) => {
            if (!applicationOnbardingStateFunctionUtils.isCurrentStepCompleted(stepRule.rule)) {
                return false;
            }
            this.completedStepsIndex.push(index);
            return true;
        });
    }
    setCompletedOnboardingItensToStepper() {
        this.completedStepsIndex.forEach((item) => this.getStepperComponentRef().setCompletedStep(item));
    }
    getCurrentActiveStep() {
        if (!this.completedStepsIndex.length) {
            this.activeItem = this.firstStepsItemList[0];
        }
        else {
            const lastCompletedStepIndex = this.completedStepsIndex[this.completedStepsIndex.length - 1];
            const currentActiveItemStepIndex = this.firstStepsItemList[lastCompletedStepIndex].stepIndex + 1;
            this.activeItem = this.firstStepsItemList[currentActiveItemStepIndex];
        }
        this.getStepperComponentRef().setActiveStep(this.activeItem.stepIndex);
    }
    async loadActiveItemViewText() {
        this.activeItemMainText = await this.$translate(this.activeItem.itemTemplate.mainText);
        this.activeItemDescription = await this.$translate(this.activeItem.itemTemplate.description);
        this.activeItemButton = await this.$translate(this.activeItem.itemTemplate.buttonText);
    }
    getStepperComponentRef() {
        this.stepperComponentRef = this.stepperComponentRef ?
            this.stepperComponentRef : document.getElementById('onboarding-stepper');
        return this.stepperComponentRef;
    }
    redirectToStep() {
        this.createStepTracking(false);
        this.$state.go(this.activeItem.itemTemplate.redirectUrl, {
            shortName: this.$rootScope.application.shortName,
        });
    }
    createStepTracking(isOpeningFirstStep) {
        this.SegmentService.createTrack(isOpeningFirstStep ? dashbotShowGetStarted : this.activeItem.itemTemplate.trackingName, {
            botName: this.myApplication.name,
            botIdentifier: this.myApplication.shortName,
            Status: 'succeed',
            CurrentStep: this.getCurrentStep(this.completedStepsIndex.length + 1),
            StepNumber: this.completedStepsIndex.length + 1,
        });
    }
    getCurrentStep(currentStep) {
        switch (currentStep) {
            case 1:
                return Steps.create;
            case 2:
                return Steps.publish;
            case 3:
                return Steps.test;
            case 4:
                return Steps.channels;
            case 5:
                return Steps.finished;
        }
    }
}
FirstStepsDashboardComponentController.$inject = ['$rootScope', 'BuilderService', 'UsersService', '$state', 'ChannelsService', '$translate', 'SegmentService', 'applicationService2'];
export const FirstStepDashboardComponent = {
    controller: FirstStepsDashboardComponentController,
    controllerAs: '$ctrl',
    template,
};
